module.exports = __webpack_public_path__ + "img/hegic.3d2a3981.svg";